/** The Starling mark — the blue plus (starling-logo-01, #3696c1), the
 * shared brand icon for the workshop apps. Inlined so the shadow DOM
 * needs no asset fetch; `public/starling-logo.svg` is the same mark for
 * the favicon. */

export const SCAPESCENE_LOGO_SVG = `
<svg class="scapescene-logo" viewBox="0 0 1024 1024" aria-hidden="true" focusable="false">
  <polygon points="912 448 576 448 576 112 448 112 448 448 112 448 112 576 448 576 448 912 576 912 576 576 912 576 912 448" fill="#3696c1"/>
</svg>
`;
